/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personas_Locked_TooltipInputs */



/**
* | output |
* | --- |
* | "Persona cannot be changed once the conversation has started" |
*
* @param {Personas_Locked_TooltipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const personas_locked_tooltip = /** @type {((inputs?: Personas_Locked_TooltipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personas_Locked_TooltipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Persona kann nach Beginn der Konversation nicht mehr geändert werden")
	return /** @type {LocalizedString} */ ("Persona cannot be changed once the conversation has started")
});